import React from 'react';
import {Flex, Scrollbar, Tag} from '@priority-software/priority-style-react';

import {isRTL} from '../../../../Localization';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';

interface Props {
    tags: string[];
    isActive: boolean;
    onRemoveTag: (value: string) => void;
}

const TagsArea = ({tags, isActive, onRemoveTag}: Props) => {
    return (
        <Scrollbar autoHeightMax={120} autoHeight={true} autoHide={false} rtl={isRTL()}>
            <Flex componentClasses={styles.tagsArea} wrap justifyContent="flex-start">
                {tags?.map((tag, index) => (
                    <Tag
                        {...createDataTestId('tag-filter-box', true)}
                        style={{marginBottom: '5px'}}
                        key={index}
                        onClose={() => onRemoveTag(tag)}
                    >
                        <bdi>{tag}</bdi>
                    </Tag>
                ))}
            </Flex>
        </Scrollbar>
    );
};

export default TagsArea;
